<core-ui-row class="mb-5 appointment-row" justify="center">
  <router-outlet />
</core-ui-row>
